<template>
  <div>
    <ReportCard
      :resource="resource"
      :code="id"
      :url="url"
      :reportIntegratedUrl="reportIntegratedUrl"
    />
  </div>
</template>
<script>
import ReportCard from "@/components/global/ReportCard";
import { generateApiUrl } from "@/shared/utils";

export default {
  name: "reports-page",
  components: {
    ReportCard,
  },
  data() {
    return {
      id: this.$route.params.id,
      resource: "center_execute",
    };
  },
  computed: {
    url() {
      return generateApiUrl(["kanoon", "center_execute_report"], [this.id]);
    },
    reportIntegratedUrl() {
      return generateApiUrl(
        ["kanoon", "report_integrated"],
        [this.resource, this.id]
      );
    },
  },
};
</script>